import $ from 'jquery';
window.addEventListener('px-ready',function(){
    redoSearch();
    $('.px-repertoire-search select').on('change',function(){
        redoSearch();
    })
})

function redoSearch(){
    var region = $('[data-type=region]').find(':selected').attr('value');
    var service = $('[data-type=service]').find(':selected').attr('value');
    var specialite = $('[data-type=specialite]').find(':selected').attr('value');
    var region_name = ($('[data-type=region]').find(':selected').attr('value')) ? $('[data-type=region]').find(':selected').text() : $('.px-search-count').attr('data-all-region') ;
    var service_name = ($('[data-type=service]').find(':selected').attr('value')) ? $('[data-type=service]').find(':selected').text() : $('.px-search-count').attr('data-all-service') ;
    var specialite_name = ($('[data-type=specialite]').find(':selected').attr('value')) ? $('[data-type=specialite]').find(':selected').text() : $('.px-search-count').attr('data-all-specialite') ;
    console.log(region)
    console.log(service)
    console.log(specialite)
    if(region || service || specialite){
        $('.search-container').addClass('searched');
    }else{
        $('.search-container').removeClass('searched');
    }
    //faisant affaire
    $('.faisant-affaire .px-card-membre').each(function(){
        $(this).removeClass('inactive');
        if(region){
            if(!$(this).attr('attr-regions').includes(region) || $(this).attr('attr-regions-siege') == region){
                $(this).addClass('inactive');
            }
        }
        if(service){
            if(!$(this).attr('attr-service').includes(service)){
                $(this).addClass('inactive');
            }
        }
        if(specialite){
            if(!$(this).attr('attr-specialite').includes(specialite)){
                $(this).addClass('inactive');
            }
        }
    })
    //siege sociaux
    $('.siege-social .px-card-membre').each(function(){
        $(this).removeClass('inactive');
        if(region){
            if(!$(this).attr('attr-regions').includes(region) || $(this).attr('attr-regions-siege') != region){
                $(this).addClass('inactive');
            }
        }
        if(service){
            if(!$(this).attr('attr-service').includes(service)){
                $(this).addClass('inactive');
            }
        }
        if(specialite){
            if(!$(this).attr('attr-specialite').includes(specialite)){
                $(this).addClass('inactive');
            }
        }
    })
    $('.px-search-count .result-count').html($('.px-card-membre:not(.inactive)').length)
    $('.px-search-count .criteria').html(region_name+', '+service_name+', '+specialite_name);
    //console.log(window.location.pathname);
    if($('.px-search-count').length){
        if(region || service || specialite){
            window.history.pushState("","",window.location.pathname+"?region="+region+"&service="+service+"&specialite="+specialite)
        }
    }
    //cleanup des cols
    $('.px-card-membre').each(function(){
        if(!$(this).hasClass('inactive')){
            $(this).parent().removeClass('d-none');
        }else{
            $(this).parent().addClass('d-none');
        };
    })
}